<template>
  <UModal key="addToQuote" v-model:open="isOpen">
    <UButton
      :ui="{ base: 'p-2 rounded-sm shadow-lueur-bleu' }"
      :icon="iconName"
      size="md"
      color="primary"
      :disabled="!props.isAuthenticated || isAdding"
      class="dj-add-to-quote-btn"
      :loading="isAdding"
      @click.stop.prevent="isOpen = true"
    />
    <template #content>
      <DjAddProductForm
        :title="$t('DjAddToQuoteButton.addQuote')"
        :icon="iconName"
        :select-text="$t('DjAddToQuoteButton.selectQuote')"
        :select-placeholder="$t('DjAddToQuoteButton.placeholder')"
        :create-text="$t('DjAddToQuoteButton.createQuote')"
        :input-placeholder="$t('DjAddToQuoteButton.namePlaceholder')"
        :options="quoteList"
        @close="isOpen = false"
        @select="selectQuote"
        @submit="(name: string) => addOrCreateToQuote(name, selected)"
      />
    </template>
  </UModal>
</template>

<script setup lang="ts">
  const props = defineProps({
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    lines: {
      type: Array<{
        variantId: string;
        quantity: number;
      }>,
      required: true,
    },
  });

  const emit = defineEmits(['added', 'error']);
  const { addOrUpdateQuote } = useQuote();
  const { getUserCurrency } = useUser();
  const currency = computed(() => getUserCurrency());
  const iconName = 'i-heroicons-document-text';
  const isAdding = ref(false);
  const isOpen = ref(false);
  const selected = ref('');
  const quoteStore = useQuoteStore();
  const quoteList = computed(() =>
    quoteStore.quotes.filter((quote: MasterQuote) => quote.supplierQuotes.length === 0)
  );

  const selectQuote = (selectedId: string) => (selected.value = selectedId);

  const addOrCreateToQuote = async (name: string, selectedId: string) => {
    if (!props.isAuthenticated) return;
    try {
      isAdding.value = true;

      const response = await addOrUpdateQuote({
        currency: currency.value,
        actionType: name ? 'create' : 'update', // create or update
        quoteId: selectedId,
        name,
        lines: props.lines, // Accepts multiple lines passed as a prop
      });

      emit('added', response); // Emit success event
      isOpen.value = false;
    } catch (error) {
      console.error('Failed to add products to cart:', error);
      emit('error', error); // Emit error event
      isOpen.value = false;
    } finally {
      isAdding.value = false;
    }
  };
</script>

<style lang="scss">
  .dj-add-to-quote-btn {
    font-family: var(--font-1st);
    font-size: 14px;
    font-weight: 700;
    color: white;
  }
</style>
